module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/label_small_question.c7ed6.png";